import { cn } from '@/lib/utils';
import { Dialog, DialogContent, DialogTitle } from '@/libs/components/src/lib/ui/dialog';

import React from 'react';

type Props = {
  isOpen: boolean;
  children: React.ReactNode | React.ReactNode[];
  close: () => void;
  className?: string;
  disableClickOutsideClose?: boolean;
  size?: React.ComponentProps<typeof DialogContent>['size'];
};

const Modal: React.FC<Props> = ({
  isOpen,
  children,
  close,
  className = '',
  disableClickOutsideClose = false,
  size = 'default',
}) => {
  const closeModal = (open: boolean) => {
    if (!open) {
      close();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={closeModal} modal>
      <DialogTitle className="sr-only">Modal</DialogTitle>
      <DialogContent
        size={size}
        className={cn('bg-white p-6 print:hidden', className)}
        onPointerDownOutside={e => {
          if (disableClickOutsideClose) {
            e.preventDefault();
          }
        }}
        onEscapeKeyDown={e => {
          if (disableClickOutsideClose) {
            e.preventDefault();
          }
        }}
        showCloseButton={false}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
